import { Component } from '@angular/core';
import { RecorderSessionService } from '../../Services/recorder-session.service';

@Component({
  selector: 'ze-web-recorder',
  templateUrl: './web-recorder.component.html',
  styleUrls: ['./web-recorder.component.scss']
})
export class WebRecorderComponent {

  constructor(
    public recorderSession: RecorderSessionService
  ) {}
}
